export enum CasinoGameSlug {
  WheelOfFortune = "wheel-of-fortune",
  CoinFlip = "coin-flip",
  Upgrader = "upgrader",
}

export enum GameSlug {
  PS99 = "ps99",
  MM2 = "mm2",
  AdoptMe = "adopt-me",
}

export type AnyGameSlug = GameSlug | `${GameSlug}`

export enum GiveawayStatus {
  PENDING = "pending",
  STARTED = "started",
  FINISHED = "finished",
}

export enum RoomStatuses {
  pending = "pending",
  started = "started",
  finished = "finished",
}
